import type { ReactElement } from 'react';

/**
 * 로고와 같은 -11° 형광펜 자국 — 이 시스템의 대표 강조다.
 *
 * 민트는 흰 바탕에서 글자로 쓰면 1.29:1 로 사라진다. 그래서 강조하고 싶은 말은
 * 글자색을 바꾸지 않고 민트 면을 밑에 긋는다(면 위 잉크 글자는 15.48:1).
 */
export function Highlight({ children }: { children: string }): ReactElement {
  return (
    <span className="relative isolate inline-block px-1 text-on-mint">
      <span
        aria-hidden="true"
        className="-inset-x-[0.16em] absolute inset-y-[0.08em] -z-10 bg-primary [transform:skewX(var(--slant))]"
      />
      {children}
    </span>
  );
}
